export default "__VITE_ASSET__DQERhj9r__"